<template>
    <aside class="push-panel">
        <div class="push-panel__main-content">
            <VJoyWrapper justify="space-between">
                <div class="push-panel__text-wrapper">
                    <p class="push-panel__title">{{ t('profile.section.mission.empty.malt.start.panel.title') }}</p>
                    <p class="push-panel__text">{{ t('profile.section.mission.empty.malt.start.text') }}</p>
                </div>
                <VJoyButton size="small" variant="secondary" @click="redirect">
                    {{ t('profile.section.mission.empty.malt.start.cta.label') }}
                </VJoyButton>
            </VJoyWrapper>
        </div>
    </aside>
</template>

<script setup lang="ts">
    import {navigateTo} from '@typed-router';
    import {useTranslation} from '#imports';
    import {VJoyButton, VJoyWrapper} from '@maltjoy/core-vue';

    const {t} = useTranslation();

    const props = defineProps<{
        link: string;
    }>();

    async function redirect() {
        await navigateTo(props.link, {external: true});
    }
</script>

<style lang="scss" scoped>
    .push-panel {
        color: var(--joy-color-neutral-0);
        background-color: var(--joy-color-tertiary-30);
        border-radius: var(--joy-core-radius-3);
        padding: var(--joy-core-spacing-5);
        .joy-wrapper {
            margin-bottom: 0;
        }

        &__title {
            font-family: var(--joy-font-family-title);
            font-weight: var(--joy-font-weight-normal);
            font-size: var(--joy-font-size-secondary-200);
            line-height: var(--joy-line-height-small);
            margin-bottom: 0;
        }
    }
</style>
